import {
  API_DATE_FORMAT,
  formatDate,
} from '@repo-level/core-profile/helpers/date';
import { Locale } from 'languages';
import moment from 'moment';

export const formatDateByLocale = (date: string, locale: string): string => {
  if (locale === Locale.GERMAN) {
    return formatDate(date);
  }
  return date;
};

export function getCurrentMonthStartDate() {
  return moment.utc().startOf('month').format(API_DATE_FORMAT);
}

export function isInCurrentMonth(date: string) {
  const utcNow = moment.utc();
  const utcDate = moment.utc(date);
  return utcDate.isSame(utcNow, 'month');
}

export function isInCurrentWeek(date: string) {
  const utcNow = moment.utc();
  const utcDate = moment.utc(date);
  return utcDate.isSame(utcNow, 'week');
}

export function isInCurrentDay(date: string) {
  const utcNow = moment.utc();
  const utcDate = moment.utc(date);
  return utcDate.isSame(utcNow, 'day');
}
